import { Component, Input } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@Component({
  selector: 'yat-password-checklist',
  templateUrl: './password-checklist.component.html',
  styleUrls: ['./password-checklist.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class PasswordChecklistComponent {
  @Input()
  letters: boolean = false;

  @Input()
  numbers: boolean = false;

  @Input()
  length: boolean = false;
}
